<template>
    <div class="page-store" :style="{ minHeight: noHead === 'true' ? '100%' : '50%', height: noHead === 'true'? '60%' : '100%' }">
        <keep-alive exclude="storeNav">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
import {mapMutations} from 'vuex'
import Customer from '@/components/overlay/customer'
    export default {
        props: {
            noHead: {
                type: String,
            },
			noFooter: {
				type:String,
				default: 'false'
			}
        },
        methods : {
            ...mapMutations({
                setShowCustomer: "setShowCustomer",
				setShowFooter: "setShowFooter",
            }),
        },
        created () {
            this.setShowCustomer(true)
			this.setShowFooter(!Boolean(this.noFooter === 'true'));
        }
    }
</script>

<style lang="scss" scoped>
.page-store {
	margin-bottom: .3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/index.vue